// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Close from "@ces/XDL/Icons/Close";
import { buttonTransparent } from "@ces/XDL/PreStyle/button";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { xBaseTheme } from "@ces/XDL/types";
import { color, styledScrollbar, xScreen } from "@ces/XDL/Utilities";
import { ButtonIcon } from "@insite/mobius/Button";
import ModalPresentationPropsDefault from "@insite/mobius/Modal/presentationProps";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

export default {
    sizeVariants: {
        small: 420,
        medium: 884,
        large: 1230,
    },
    defaultProps: {
        ...ModalPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            headlineTypography: css`
                margin-bottom: 0;
                letter-spacing: 0;
                line-height: 30px;
            `,
            modalTitle: css`
                &&& {
                    position: relative;
                    padding: 0 0 8px 0;
                    border-bottom: 1px solid ${color("common.border")};
                    margin: 16px 16px 0 16px;
                }
            `,
            modalContent: css`
                &&& {
                    ${styledScrollbar()}
                    padding: 16px;
                }
            `,
            modalBody: css`
                &&& {
                    border-radius: 2px;
                    background-color: ${color("common.white")};
                    border: 1px solid ${color("common.border")};
                    overflow: visible;
                    ${xScreen("lte", "md")} {
                        width: fit-content;
                        min-width: 50%;
                        max-width: 90%;
                        height: auto;
                        max-height: calc(100% - 30px);
                        margin: 15px;
                    }
                }
            `,
        },
        headlineTypographyProps: {
            size: 24,
            weight: fontConfig.weight.bold,
            lineHeight: "30px",
            color: "text.main",
        },
        closeButtonProps: {
            mergeCss: true,
            shape: "pill",
            buttonType: "solid",
            css: css`
                width: 30px;
                height: 30px;
                min-height: auto;
                padding: 0;
                ${buttonTransparent}
                ${ButtonIcon} {
                    color: ${color("text.link")};
                    background: none;
                }
                &:hover {
                    ${ButtonIcon} {
                        color: ${color("text.link", 0.5)};
                    }
                }
            `,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: Close,
            size: 14,
            color: "text.link",
            css: css`
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            `,
        },
    },
} as xBaseTheme["modal"];
